import type { Combo, MenuInput, Product, ScoredItem, ScoringWeights } from "./types.js";
import { stableSort } from "./utils.js";

function scoreProduct(product: Product, weights: ScoringWeights): ScoredItem {
  const popularity = (product.popularity ?? 50) / 100;
  const margin = (product.margin ?? 50) / 100;
  const score = popularity * weights.popularity + margin * weights.margin;

  return {
    id: product.id,
    type: "product",
    categoryId: product.categoryId,
    score,
    name: product.name,
    price: product.price,
    image: product.image,
  };
}

function scoreCombo(combo: Combo, weights: ScoringWeights): ScoredItem {
  const popularity = (combo.popularity ?? 50) / 100;
  const margin = (combo.margin ?? 50) / 100;
  const score = weights.combo + popularity * weights.popularity + margin * weights.margin;

  return {
    id: combo.id,
    type: "combo",
    categoryId: null,
    score,
    name: combo.name,
    price: combo.price,
    image: combo.image,
  };
}

export function scoreAndRank(input: MenuInput, weights: ScoringWeights): ScoredItem[] {
  const scored: ScoredItem[] = [];

  for (const product of input.products) {
    scored.push(scoreProduct(product, weights));
  }

  if (input.combos) {
    for (const combo of input.combos) {
      scored.push(scoreCombo(combo, weights));
    }
  }

  return stableSort(scored, (a, b) => {
    const scoreDiff = b.score - a.score;
    if (scoreDiff !== 0) return scoreDiff;
    return a.id.localeCompare(b.id);
  });
}
